import { doHttp, getLoginUser } from '../util/common'
import { HTTP_TYPE_GET, HTTP_TYPE_POST } from '../util/constants'

/**
 *获取最新发布的贸易列表接口，不包含已下架
 * @param limitCount 获取条数
 * @returns {*}
 */
export function apiLatestPublishedTradeList (limitCount) {
  let params = {
    limitCount
  }

  return doHttp('/trade/v1/getLatestPublishedTradeList', HTTP_TYPE_POST, params)
}

/**
 *获取诚意发布的贸易列表接口，不包含已下架
 * @param limitCount 获取条数
 * @returns {*}
 */
export function apiSincereTradeList (limitCount, type) {
  let params = {
    limitCount,
    type
  }

  return doHttp('/trade/v1/getSincereTradeList', HTTP_TYPE_POST, params)
}

/**
 *获取热门推荐的贸易列表接口，不包含已下架
 * @param page 第几页
 * @param rows 当前页显示几行
 * @returns {*}
 */
export function apiRecommendTradeList (page, rows) {
  let params = {
    page,
    rows
  }
  return doHttp('/trade/v1/getRecommendTradeList', HTTP_TYPE_POST, params)
}

/**
 * 获取贸易列表接口，不包含已下架。
 * @param params
 * @returns {*}
 */
export function apiSearchTradeList (obj) {
  let params = {...obj}
  if (params.industryCode === 'industry1') {
    params.industryCode = ''
  }
  if (params.payCode === 'paycode1') {
    params.payCode = ''
  }
  if (params.invoiceCode === 'invoice1') {
    params.invoiceCode = ''
  }
  if (params.townName === '不限') {
    params.townName = ''
  }
  if (params.cityName === '不限') {
    params.cityName = ''
  }
  if (params.provinceName === '不限') {
    params.provinceName = ''
  }
  return doHttp('/trade/v1/getTradeListBySearch', HTTP_TYPE_POST, params)
}

/**
 * 获取贸易列表接口，不包含已下架。
 * @param page 第几页
 * @param rows 当前页显示几行
 * @returns {*}
 */
export function apiSuccessMatchList (page, rows) {
  let params = {
    page,
    rows
  }
  return doHttp('/trade/v1/getSuccessMatchList', HTTP_TYPE_POST, params)
}

/**
 * 获取贸易详情
 * @param id
 * @returns {*}
 */
export function apiTradeDetail (tradeId) {
  let loginUser = getLoginUser()
  let params = {
    tradeId,
    userId: loginUser == null ? 0 : loginUser.id
  }
  return doHttp('/trade/v1/getTradeDetail', HTTP_TYPE_POST, params)
}

/**
 * 获取我发布的贸易列表接口
 * @param tradeId
 * @returns {*}
 */
export function apiOwnPublishTradeList (page, rows, type) {
  let params = {
    page,
    rows,
    type
  }
  return doHttp('/trade/v1/authApi/getOwnPublishTradeList', HTTP_TYPE_POST, params)
}

/**
 * 获取我对接的贸易列表接口，不包含已下架
 * @param page
 * @param rows
 * @param type
 * @returns {*}
 */
export function apiDockingTradeList (page, rows, type) {
  let params = {
    page,
    rows,
    type
  }
  return doHttp('/trade/v1/authApi/getDockingTradeList', HTTP_TYPE_POST, params)
}

/**
 * 获取我收藏的贸易列表接口，不包含已下架
 * @param page
 * @param rows
 * @param type
 * @returns {*}
 */
export function apiCollectedTradeList (page, rows, type) {
  let params = {
    page,
    rows,
    type
  }
  return doHttp('/trade/v1/authApi/getCollectedTradeList', HTTP_TYPE_POST, params)
}

/**
 * 获取贸易对接列表接口
 * @param page
 * @param rows
 * @param tradeId
 * @returns {*}
 */
export function apiTradeDockingApplyList (page, rows, tradeId) {
  let params = {
    page,
    rows,
    tradeId
  }
  return doHttp('/tradeDocking/v1/authApi/getTradeDockingApplyList', HTTP_TYPE_POST, params)
}

/**
 * 发布贸易
 * @param params
 * @returns {*}
 */
export function apiPublishTrade (params) {
  return doHttp('/trade/v1/authApi/publishTrade', HTTP_TYPE_POST, params)
}



// WEBPACK FOOTER //
// ./src/api/trade.js